<template>
  <div>
    <h1>History Reconsidered</h1>
  </div>
</template>

<script>
export default {};
</script>
